export default {
  methods: {
    axiosReqestError(title, message) {
      let options = {
        progressBar: true,
        positionClass: "toast-bottom-left",
        timeOut: 5000,
      };

      this.$toastr.error(message, title, options);
    },
    axiosReqestSuccess(title, message) {
      let options = {
        progressBar: true,
        positionClass: "toast-bottom-left",
        timeOut: 5000,
      };

      this.$toastr.success(message, title, options);
    }
  }
};
